module.exports = __webpack_public_path__ + "static/media/A1-29-Devorax-cod137.ae5b10e9.png";